// The enums of the reference data that travel in the contracts: @nexxt/db builds the Postgres enums from these tuples.

/** `reference.location_type`. */
export const locationTypes = ["warehouse", "return_location", "faulty_goods", "transit", "virtual"] as const;
export type LocationType = (typeof locationTypes)[number];

/** `reference.payment_category`. open_terms: invoice and release at once; proforma: release only after payment. */
export const paymentCategories = ["open_terms", "proforma"] as const;
export type PaymentCategory = (typeof paymentCategories)[number];

/** `reference.tax_destination`: where a VAT rule applies. */
export const taxDestinations = ["domestic", "eu", "extra_eu", "any"] as const;
export type TaxDestination = (typeof taxDestinations)[number];

// TODO(V-16): the four types of the PIM page of TLG; which category gets which, and who keeps the table, is B-113
/**
 * The type of an item the file of the items to the ERP requires (spec v0.3 §7.3.2 #13, ADR-257): how the warehouse
 * handles it. A product category or subcategory gives it, a style may override it.
 */
export const erpProductTypes = ["FRAGILE", "HANGING", "FLAT", "SHOE"] as const;
export type ErpProductType = (typeof erpProductTypes)[number];

/**
 * The two sides of the invoices file to the ERP (spec v0.3 §7.4, ADR-256): the invoices of the suppliers (purchase,
 * the passive ones) and the invoices Nexxt numbers (sales, the active ones). Finance keeps the register and the
 * dimensions of each, per company.
 */
export const erpInvoiceDirections = ["purchase", "sales"] as const;
export type ErpInvoiceDirection = (typeof erpInvoiceDirections)[number];
